import * as React from "react";
const SvgFiRrChessBishop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chess-bishop_svg__a)">
      <path
        fill="#062147"
        d="M19 22h-1.35A8.99 8.99 0 0 0 21 15c0-4.677-5.961-9.848-7.846-11.367A2 2 0 1 0 10.8 3.6C8.786 5.01 3 9.531 3 15a8.99 8.99 0 0 0 3.35 7H5a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2M5 15c0-4.485 5.2-8.526 6.958-9.765a33.4 33.4 0 0 1 3.4 3.172l-4.127 4.952a1 1 0 1 0 1.536 1.282l3.913-4.695C18 11.62 19 13.423 19 15a7 7 0 0 1-14 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chess-bishop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChessBishop;
